

// general structure of the query keys that should probably work for most cases
export const orgKeys = {
  all: ['orgs'],
  organizations: () => [...orgKeys.all],
  organization: (id) => [...orgKeys.organizations(), id],
  orgSettings: (id) => [...orgKeys.organization(id), 'settings'],
  tenant: (data) => [...orgKeys.organizations(), data],
  privileges: (data) => [...orgKeys.organizations(), data]
};
